import React from "react";

import {styled} from "@styled-system/jsx";
import {buttonV2, icon, spinner} from "@styled-system/recipes";

import type {ButtonV2VariantProps} from "@styled-system/recipes";
import type {SystemStyleObject} from "@styled-system/types";

import {css, cx} from "@styled-system/css";

export type ButtonProps = ButtonV2VariantProps & //exported for toast
    React.ButtonHTMLAttributes<HTMLButtonElement> & {
        isLoading?: boolean;
        icon?: React.ReactNode;
        textDirection?: "row" | "column";
        css?: SystemStyleObject;
        asChild?: boolean;
    };

const Spinner = styled("div", spinner);
const IconWrapper = styled("span", icon);

export const ButtonV2 = React.forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            children,
            className,
            isLoading,
            disabled,
            icon,
            variant,
            size,
            width,
            textStyle,
            css: cssProp,
            textDirection = "row",
            ...props
        },
        ref
    ) => {
        return (
            <button
                ref={ref}
                disabled={disabled || isLoading}
                className={cx(buttonV2({variant, size, width, textStyle}), cssProp && css(cssProp), className)}
                {...props}>
                <span
                    className={css({
                        display: "flex",
                        alignItems: "center",
                        pl: 2,
                        pr: 1,
                        flexDirection: textDirection
                    })}>
                    {isLoading && <Spinner size="sm" variant="thin" css={{mr: "4px"}} />}
                    {icon && <IconWrapper size="sm">{icon}</IconWrapper>}
                    {children}
                </span>
            </button>
        );
    }
);

ButtonV2.displayName = "ButtonV2";
